export const InsuranceStates = Object.freeze({
  TRUE: 1,
  NOT_SPECIFIED: 0,
  FALSE: -1,
});
